import { Tabs } from "antd";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { getAllParamsFromLocation, addOrReplaceQueryParam } from "../../../helper/loc";
import Year from "../../analysis/year";
import Month from "../../analysis/month";
import SiteAnalysis from "../../analysis/site";
import GHGCategory from "../../analysis/ghgcategory";
import ResultTags from "../../analysis/resulttags";


const { TabPane } = Tabs;


export default function AnalysisConsultant() {
    const location = useLocation();
    const [activeKey, setActiveKey] = useState(() => {
        const params = getAllParamsFromLocation();
        return params.name || "1";
    });

    const handleTabChange = (key) => {
        setActiveKey(key);
        addOrReplaceQueryParam("name", key);
    };

    return (
        <Tabs activeKey={activeKey} onChange={handleTabChange}>
            <TabPane tab="Years" key="Years">
                <Year />
            </TabPane>
            <TabPane tab="Months" key="Months">
                <Month />
            </TabPane>
            <TabPane tab="Sites" key="Sites">
                <SiteAnalysis />
            </TabPane>
            <TabPane tab="GHG Category" key="GHG Category">
                <GHGCategory />
            </TabPane>
            <TabPane tab="Data Tags" key="Data Tags">
                <ResultTags />
            </TabPane>
        </Tabs>
    );
}
